import React, { useState, useEffect } from 'react';
import { Icon, Message, Header } from 'semantic-ui-react';
import './CheckPassword.css';

/**
 * Retoure l'affichage des élements requit pour un bon mot de passe
 * @param string props.password
 * @param Object props.translations
 */
const CheckPassword = (props) => {
  const [passwordState, setPasswordState] = useState(false);

  useEffect(() => {
    setPasswordState(props.password);
  }, [props.password]);

  /**
   * Check le mot de passe est affiche le statut des differents critere du mot de passe
   * @param int index 
   * @param array listData 
   */
  const getCheckRow = (index, listData) => {
    let regex,
      text = '',
      icon = 'exclamation';

    switch (listData[index]) {
      case 'upperCase':
        text = props.translations.contentPasswordUpperCase;
        regex = new RegExp("^(?=.*[A-Z])");
        if (regex.test(passwordState)) {
          icon = 'check';
        }
        break;
      case 'lowerCase':
        text = props.translations.contentPasswordLowerCase;
        regex = new RegExp("^(?=.*[a-z])");
        if (regex.test(passwordState)) {
          icon = 'check';
        }
        break;
      case 'numberCase':
        text = props.translations.contentPasswordNumberCase;
        regex = new RegExp("^(?=.*[0-9])");
        if (regex.test(passwordState)) {
          icon = 'check';
        }
        break;
      default:
        text = props.translations.contentPasswordMinCharsCase;
        regex = new RegExp("^(?=.{8,})");
        if (regex.test(passwordState)) {
          icon = 'check';
        }
        break;
    }

    return (
      <Header key={index} as="p" className="mt-2" color={(icon !== "exclamation") ? "green" : "red"}>
        <Icon name={icon + ' circle'} />
        {text}
      </Header>
    );
  }

  /**
   * Retourne la liste des differents criteres du mot de passe
   * @returns array itemTrad
   */
  const getListCondition = () => {
    let itemTrad = [],
      listData = ['upperCase', 'lowerCase', 'numberCase', 'minCharsCase']

    for (let index in listData) {// eslint-disable-line no-unused-vars
      itemTrad.push(getCheckRow(index, listData));
    }
    return itemTrad;
  }

  /**
   * Rendu du module
   * @returns Object jsx
   */
  return (
    <Message info id="msgPassword">
      <Message.Header>{props.translations.contentPassword} :</Message.Header>
      {getListCondition()}
    </Message>
  );
}

export default CheckPassword;